import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { CommonUtil } from '../../core/Utils/common-util';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { OnDemandClassesService } from '../services/on-demand-classes.service';
import { Router } from '@angular/router';
import { SafeHtml } from '@angular/platform-browser';
import { HaloToastService } from '../../core/halo-toast/halo-toast.service';
import { HaloLoaderService } from '../../core/halo-loader/halo-loader.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { MultipleFacilityPublish } from 'src/app/core/services/facility.model';
import { IstatusCountData, IBandwidth, IOnDemandClassesEquipment, IconfiramtionCountData, IOnDemandClassesAsset, IOnDemandClassesWrapper} from '../services/on-demand-classes.service.model';

import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips';
import { MultiFacilityService } from '../services/multi-facility.service';
import { SelectionInfo } from '../selectors/multi-selection/multi-selection.model';
import { Subscription } from 'rxjs';
import { VideoLibraryService } from '../video-library/video-library.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { PreviewModalData } from '../preview-modal/preview-modal.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-enable-equipment',
  templateUrl: './enable-equipment.component.html',
  styleUrls: ['./enable-equipment.component.css'],
})
export class EnableEquipmentComponent implements OnInit, OnDestroy {
  
  private isPremium = false;
  private selectionInfo: SelectionInfo;
  private rootscopeSubs: Subscription;

  rootScopeData: RootScopeDeclare;

  productInfoGridData: IOnDemandClassesEquipment[];
  statusCountData: IstatusCountData;
  confirmationCountList: IconfiramtionCountData;
  isEquipmentListFetched = false;
  showDisableModal = false;
  showOutdatedSoftwareModal = false;
  isEnabled: string = 'true';
  isLifescape: string = 'true';
  isCustomLibrary: string = 'true';
  assetList: IOnDemandClassesAsset[] = [];
  showToast = false;
  toastMessage: string;
  consolePermision = 'hasLfodEnabledEquipment';
  LFOnDemandConsoles = ['superman', 'hal', 'everest', 'neo_se4', 'falco'];
  productInfoHeaderColumn: object;
  userPermission: boolean = false;
  warningMessage: string | SafeHtml;
  showBandwidthModal = false;
  recommendedBandwidth: IBandwidth[] = [];
  bandwidthList: {
    name: string | undefined,
    unit: number | undefined,
    value: string | undefined
  }[] = [];
  lfOnDemandHeaderMsg: string = '';

  disabledPopupProperties = {
    title: 'DISABLE.LF.ON.DEMAND.CLASSES',
    message: 'DISABLE.LF.ON.DEMAND.CLASSES.MSG',
    isWarningPopup: false,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };

  outdatedSoftwarePopupProperties = {};

  productInfoHeaderData = [
    { columnName: 'PRODUCT.INFORMATION' },
    { columnName: 'STATUS' },
    { columnName: 'CONFIRMATION' },
    { columnName: 'SELECT.ALL.EQUIPMENT' },
  ];

  productInfoHeaderDataForXs = [{ columnName: 'STATUS' }, { columnName: 'SELECT.ALL.EQUIPMENT' }];
  
  displayPreviewModal = false;
  status: string;
  enableBtnLabel: string;

  constructor(
    private rootScopeService: RootScopeService,
    private onDemandClassesService: OnDemandClassesService,
    public commonUtil: CommonUtil,
    private router: Router,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private toast: HaloToastService,
    private _facilityService: FacilityService,
    private _multiFacilityService: MultiFacilityService,
    private loader: HaloLoaderService,
    private videoLibraryService: VideoLibraryService,
    private _tips: HaloTipsService,
    private _featureFlagService: FeatureFlagsService
  ) {
  }

  showHaloTips() {
    if(this.rootScopeData.showLFODTooltip){
      this._tips.add([
        {flag: 'showLFODTooltip', key: 'multi-select-facility', message: this.commonUtil.translateText('LF.ON.DEMAND.TOOLTIP.NEW.MSG1'),noSkip:true }
      ]);
    }
  }

  isLifescapeVisible() {
    return this.selectionInfo?.consoleType !== 'mulder' && this._featureFlagService.isOn('se3HD');
  }

  getRootScopeData(): void {
    this.rootscopeSubs = this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  updateOnDemandData() {
    if (!this.hasPermission()) {
      this.commonUtil.redirectToAvailablePage();
    }
    this.getOnDemandClassesDetails();
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();
    this.isPremium = this.router.url === "/enable_equipment";
    if(this.isPremium) {
      this.LFOnDemandConsoles.push('mulder');
      this.consolePermision = 'hasLfodEnabledEquipment';
    }

    this.changeProductInfoHeaderData();
    const moduleTitle =
      this.commonUtil.translateText('HALO.FITNESS.CLOUD') + ' - ' + this.commonUtil.translateText('MENU.EQUIPSETTING');
    this.commonUtil.setTitle(moduleTitle);
    const gettingStartedLink = [
      '<a class="gettingStartedLink"  target="_blank" href="http://kb.cybexintl.com/Instructions/Console/Life_Fitness_On_Demand_Getting_Started_Guide_9.30.pdf">' +
        this.commonUtil.translateText('HERE') +
        '</a>',
    ];
    this.warningMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASS.WARNING.NEW.MSG',
      gettingStartedLink
    );
    this.showHaloTips();

    // static data
    this.recommendedBandwidth = this.onDemandClassesService.recommendedBandwidths();
    this.updateEnableBtnLabel(this.isEnabled === 'true');
  }

  ngOnDestroy() {
    // $('#atlwdg-trigger').css('display', "none");
    // destroy subscriber
    this.rootscopeSubs?.unsubscribe();
    this._tips.onDismissed(true);
  }

  @HostListener('window:resize', ['$event'])
  setScreenSize(): void {
    this.changeProductInfoHeaderData();
  }

  changeProductInfoHeaderData(): void {
    this.productInfoHeaderColumn =
      this.rootScopeData.screenSize == 'xs' || this.rootScopeData.screenSize == 'sm'
        ? this.productInfoHeaderDataForXs
        : this.productInfoHeaderData;
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'onDemandClasses';
  }

  getHeaderMessage(){
    let lfOnDemandTxt = this.getLfOnDemandConsoles();        
    this.lfOnDemandHeaderMsg = `${this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASSES.HEADER.NEW.MSG', 
      [lfOnDemandTxt])} <a href="https://lifefitness9512.zendesk.com/hc/en-us/articles/7709126359575" target="_blank"> ${this.commonUtil.translateText('LEARN.MORE')} </a>`
   
  }

  getLfOnDemandConsoles(){
    let supportedConsolesTxt: string = '';
    let supportedConsoles: string[] = [];
    this.selectionInfo.multiFacilities?.forEach(f => {
      let fac = this._facilityService.getFacilityById(f);
      fac?.consoleEquipments      
      ?.filter((console) => this.LFOnDemandConsoles.includes(console.consoleType)? console.consoleType: '')
      .forEach((console) => supportedConsoles.push(this.rootScopeData.consoleRights.get(console.consoleType).consoleName));
    });
    supportedConsolesTxt = supportedConsoles
      .filter((v, i, a) => a.indexOf(v) === i)
      ?.join(', ')
      .replace(/,(?!.*,)/gim, ' ' + this.commonUtil.translateText('AND'));
    return supportedConsolesTxt;
  } 

  getOnDemandClassesDetails() {
    this.userPermission = this.hasEditPermission();
    if (this.selectionInfo.consoleType && this.LFOnDemandConsoles.indexOf(this.selectionInfo.consoleType.toString()) > -1) {
      this.loader.startProcess();
      this.videoLibraryService
         .getEnabledEquipment(this._facilityService.selectedMultiFacilities().map(i=>Number(i)), this.selectionInfo.consoleType)
         .subscribe(
          (data: IOnDemandClassesWrapper[]) => {
            this.loader.endProcess();
            this.isEquipmentListFetched = true;
            this.productInfoGridData = this.onDemandClassesService.groupAssetByType(data, this.selectionInfo.consoleType, 'lfodEnabledEquipment');
            this.constructDataForStatusLegend();
            this.constructDataForConfirmationLegend();
            this.isEnabled = data.filter(c => c.lfodEnabledStatus)?.length ? 'true' : 'false';
            this.isLifescape = data.filter(c => c.lifescapeEnabledStatus)?.length ? 'true' : 'false';
            this.isCustomLibrary = data.filter(c => c.customLibraryEnabledStatus)?.length ? 'true' : 'false';
            this.updateEnableBtnLabel(this.isEnabled === 'true');
          },
          error => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
    }
  }

  constructDataForStatusLegend(): void {
    this.statusCountData = {
      connectedCount: this.sumOfArray(this.productInfoGridData.map(p => p.connectedCount)),
      idleCount: this.sumOfArray(this.productInfoGridData.map(p => p.idleCount)),
      notConnectedCount: this.sumOfArray(this.productInfoGridData.map(p => p.notConnectedCount)),
      showIdle: true
    };
  }

   constructDataForConfirmationLegend(): void {
    this.confirmationCountList = {
      enabledCount: this.sumOfArray(this.productInfoGridData.map(p => p.enabledCount)).toString(),
      warningCount: this.sumOfArray(this.productInfoGridData.map(p => p.warningCount)).toString(),
      unknownCount: this.sumOfArray(this.productInfoGridData.map(p => p.unknownCount)).toString(),
    };
  }

  sumOfArray(array: number[]) {
    return array.reduce((p, c) => p + c);
  }

  assetListDataHandler(assetData: IOnDemandClassesAsset[]): void {
    this.assetList = assetData;
  }

  openBandwidthModal() {
    this.bandwidthList = [];
    let groupedAssets = this.onDemandClassesService.groupBy(this.assetList, asset => asset.facilityId);
    groupedAssets?.forEach((v, k) => {
      this.bandwidthList.push({
        name: v[0].facilityName,
        unit: v.length,
        value: this.getbandwith(v.length)
      });
    });
    this.showBandwidthModal = true;
  }

  getbandwith(units: number):string | undefined {
    const banLength = this.recommendedBandwidth.length;
    for(var i=0; i < banLength; i++) {
      if(this.recommendedBandwidth[i].units > units || i + 1 === banLength) {
        return this.recommendedBandwidth[i].bandwidth;
      } else if(this.recommendedBandwidth[i].units < units && this.recommendedBandwidth[i +1].units > units) {
        return this.recommendedBandwidth[i + 1].bandwidth;
      }
    }
    return undefined;
  }

  closeBandwidthModal() {
    this.showBandwidthModal = false;
  }

  prepareDataToPublish() {
    if(!this.assetList || this.assetList.length < 1) return undefined;
    let dataToPublish: MultipleFacilityPublish = {
      onDemandClassesUpdateWrapper: []
    };

    let groupedAssets = this.onDemandClassesService.groupBy(this.assetList, asset => asset.facilityId);
    groupedAssets?.forEach((v, k) => {
      dataToPublish.onDemandClassesUpdateWrapper.push({
        facilityId: k,
        consoleType: this.selectionInfo.consoleType,
        assetIds: v.map(a => a.assetId.toString()),
        lfodEnabledStatus: this.isEnabled === 'true',
        lifescapeEnabledStatus: this.isLifescape === 'true',
        customLibraryEnabledStatus: this.isCustomLibrary === 'true',
        managerId: this.rootScopeData.currentUser.userId
      });
    });

    return dataToPublish;
  }

  publishOnDemandClasses() {   
    var dataToPublish = this.prepareDataToPublish();
    if(!dataToPublish) return;
    this.loader.startProcess();
    this.amplitudeAnalytics.logEvent({ 
      elementName: 'Publish',
      action: 'Click',
      additionalProperty: {
        lfod: this.status,
        lifescape: this._featureFlagService.isOn('se3HD') ? this.isLifescape ? 'Enable' : 'Disable' : '',
        console: this.selectionInfo.consoleType,
        facilityIds: dataToPublish.onDemandClassesUpdateWrapper?.map(o => o.facilityId)
      }
    });
    this.onDemandClassesService.publishOnDemandClasses(dataToPublish.onDemandClassesUpdateWrapper).subscribe(
      (data: IOnDemandClassesWrapper[]) => {
        this.loader.endProcess();
        this.isCustomLibrary = data[0].customLibraryEnabledStatus ? 'true' : 'false';
        this.isLifescape = data[0].lifescapeEnabledStatus ? 'true' : 'false';
        this.isEnabled = data[0].lfodEnabledStatus ? 'true' : 'false';
        if(data[0].lfodEnabledStatus) {
          this.setenableToggle();
        }
        this.processPublishResponse(data);
      },
      error => {
        this.loader.endProcess();
        if (this.showBandwidthModal) {
          this.closeBandwidthModal();
        }
        console.error('API failed.');
      }
    );
  }

  stopEventCapturing(e: any) {
    e.stopPropagation();
  }

  checkEnableDisablePublish() {
    if (this.isEnabled === 'true' || this.isLifescape === 'true' || this.isCustomLibrary === 'true') {
      this.openBandwidthModal();
      this.status = 'Enable';
    } else {
      this.publishOnDemandClasses();
      this.status = 'Disable';
    }
  }

  processPublishResponse(data: IOnDemandClassesWrapper[]) {
    let outdatedAssetCount = 0;
    let additionalMessage: string[] = [];
    const consoleType = this.selectionInfo.rootScopeData.consoleRights.get(this.selectionInfo.consoleType).consoleName;
    if(consoleType.includes('SE4') || consoleType.includes('Symbio')) {
      additionalMessage.push('<b>' + this.commonUtil.translateText('LF.ON.DEMAND.NEW.CLASSES') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['5.01']));
      additionalMessage.push('<b>' + this.commonUtil.translateText('INTERACTIVE.TERRAINS') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['5.02']));
      if (this._featureFlagService.isOn('poseidon-milestone-3')) additionalMessage.push('<b>' + this.commonUtil.translateText('CUSTOM.VIDEOS') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['5.03']));
    } else if(consoleType.includes('SE3')) {
      additionalMessage.push('<b>' + this.commonUtil.translateText('LF.ON.DEMAND.NEW.CLASSES') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['4.10']));
      additionalMessage.push('<b>' + this.commonUtil.translateText('INTERACTIVE.TERRAINS') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['4.21']));
      if (this._featureFlagService.isOn('poseidon-milestone-3')) additionalMessage.push('<b>' + this.commonUtil.translateText('CUSTOM.VIDEOS') + ': </b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['4.22']));
    } else if(consoleType.includes('Cybex 70T')) {
      additionalMessage.push('<b>' + this.commonUtil.translateText('LF.ON.DEMAND.NEW.CLASSES') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['4.10']));
      if (this._featureFlagService.isOn('poseidon-milestone-3')) additionalMessage.push('<b>' + this.commonUtil.translateText('CUSTOM.VIDEOS') + ':</b>&nbsp;' + this.commonUtil.replaceValueAsHTMLOnTranslatedText('MIN.VERSION', ['4.22']));
    }
    data?.forEach(item => {
      let fac = this._facilityService.getFacilityById(item.facilityId.toString());
      if(item.outdatedAssetCount > 0) {
        outdatedAssetCount += Number(item.outdatedAssetCount);
      } 
    });
    if (outdatedAssetCount > 0) {
      this.showOutdatedSoftwareModal = true;
      this.outdatedSoftwarePopupProperties = {
        title: 'OUTDATED.SOFTWARE.VERSION',
        message: this.commonUtil.replaceValueAsHTMLOnTranslatedText('OUTDATED.SOFTWARE.VERSION.NEW.MSG', [
          outdatedAssetCount.toString(),
        ]),
        needHelp: 'NEED.HELP',
        needHelpLink: 'https://halofitness.zendesk.com/hc/en-us/articles/360031436651',
        isWarningPopup: true,
        ctaButtonLabel: additionalMessage.length > 1 ? 'OK' : 'UPDATE.SOFTWARE',
        negativeButtonLabel: additionalMessage.length > 1 ? '' : 'OK',
        isCloseIconCallsCta: false,
        isSecondaryTextButton: true,
        additionalMessage: additionalMessage
      };
    } else {
      this.toastMessage = this.commonUtil.translateText('CONTENT.MANAGER.ENABLE.EQUIPMENT.UPDATED.SETTINGS.MSG');
      this.toast.creatToast(this.toastMessage);
    }
    if (this.showBandwidthModal) {
      this.status = 'Enable';
      this.closeBandwidthModal();
    } else {
      this.status = 'Disable';
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;        
    this.updateOnDemandData();
  }

  showDisableConfirmationModal() {
    if (this.isEnabled === 'true') {
      // this.showDisableModal = true;
      this.updateEnableBtnLabel(false);
    }
  }
  setenableToggle() {
    if (this.isEnabled === 'false') {      
      this.updateEnableBtnLabel(true);
    }
  }
  needHelpLink() {
    //
  }
  onPositiveConfirmation() {
    this.showDisableModal = false;
    this.setDraftedFlag();
  }

  closeDisabledModal() {
    this.isEnabled = 'true';    
    this.updateEnableBtnLabel(true);
    this.showDisableModal = false;
  }

  goToSofwarePage() {
    this.router.navigate(['/software']);
  }

  closeOutdatedSoftwareModal() {
    this.showOutdatedSoftwareModal = false;
    this.showBandwidthModal = false;
  }

  closeToast(): void {
    this.showToast = false;
  }

  showPreviewPopup() {
    this.displayPreviewModal = true; 
  }

  onPressofCancel() {
    this.displayPreviewModal = false;
  }

  hasEditPermission() {
    if(this.selectionInfo.multiFacilities){
      return this.selectionInfo.multiFacilities.some(s => {
        let fac = this._facilityService.getFacilityById(s);
        if((fac?.summary?.userRights?.lfodEnabledEquipment === 'F' && this.isPremium) ||
          fac?.summary?.isLoggedInManagerAdmin === 'true') return true;
        else return false;
      });
    }else{
      return false;
    } 
  } 

  hasPermission() {
    if(this.selectionInfo.multiFacilities){
      return this.selectionInfo.multiFacilities.some(s => {
        let fac = this._facilityService.getFacilityById(s);
        if(((fac?.summary?.userRights?.lfodEnabledEquipment !== 'H' || fac?.summary?.isLoggedInManagerAdmin === 'true') 
          && this.isPremium && fac?.summary.facilityRights.lfodEnabledEquipment === 'true')) {
            return this._multiFacilityService.isMultifacilityUrl(this.router.url);
          }
        return false;
      });
    }
    return false;
  }

  pageName() {
    if(this.isPremium) {
      return this.commonUtil.translateText('SUBSCRIPTION.LFODP');
    } else {
      return this.commonUtil.translateText('SUBSCRIPTION.LFODB');
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.updateOnDemandData();
      this.getHeaderMessage();
    });
  }

  private updateEnableBtnLabel(isEnabled: boolean) {
    this.enableBtnLabel = this.commonUtil.translateText('PUBLISH');
  }

  getPreviewData(): PreviewModalData[] {
    const data = [{
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITH.ON.DEMAND', [this.commonUtil.translateText('LF.ON.DEMAND.NEW.CLASSES')]),
        images: [
          !this.isSe4Console() ? `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_LFOD_SE3HD.png` :
          `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_LFOD_SE4.png`,
        ],
        index: 0
      }, {
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITH.ON.DEMAND', [this.commonUtil.translateText('INTERACTIVE.TERRAINS')]),
        images: [
          !this.isSe4Console() ? `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_Lifescape_SE3HD.png` :
          `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_Lifescape_SE4.png`,
        ],
        index: 1
      }, {
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITH.ON.DEMAND', [this.commonUtil.translateText('CUSTOM.VIDEOS')]),
        images: [
          !this.isSe4Console() ? `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_CustomVideos_SE3HD.png` :
          `${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_CustomVideos_SE4.png`,
        ],
        index: 2
      }
    ];
    if (this._featureFlagService.isOff('poseidon-milestone-3')) data.splice(2, 1);
    if (!this.isLifescapeVisible()) data.splice(1, 1);
    return data;
  }

  isSe4Console() {
		const consoles = ['hal','everest', 'falco', 'neo_se4'];
    const isExist = !!consoles.find(item => item === this.selectionInfo.consoleType)
		return isExist;
	}
}
